export default "__VITE_ASSET__BGB5Q9tu__"